<template>
  <div class="info-page" :class="pageTypeClass">
    <Navigation
      :category-name="(subcategory?.external && typeof subcategory.external === 'object' && subcategory.external.title) || ''"
      :subcategory="subcategory"
    />
    <div class="content info-page__content">
      <div class="container">
        <div class="card">
          <ProductBlock v-for="(item, index) in transformedData" :key="index" :productInfo="item" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useMainStore } from '~/stores/main';
  import Navigation from '~/components/ui/Navigation.vue';
  import ProductBlock from '~/components/product/ProductBlock.vue';

  definePageMeta({ middleware: 'check-token' });

  const store = useMainStore();
  const route = useRoute();
  const categories = computed(() => store.categories);

  // Use dynamic key based on route params to force refresh on navigation
  const { data: infoPageData } = await useAsyncData(
    `infoPageData-${route.params.category}`,
    async () => {
      // Ensure global/server init if categories are missing
      if (!Array.isArray(store.categories) || store.categories.length === 0) {
        await store.serverInit({ route, params: route.params });
      }
      await store.setInfoPageData({ params: route.params, routeName: route.name as string });
      return store.infoPageData;
    },
    {
      watch: [() => route.params.category]
    }
  );
  const systemPageList = computed(() => {
    return categories.value.filter((category) => route.params.category == category.nodeId);
  });
  const subcategory = computed(() => systemPageList.value[0]);
  const pageTypeClass = computed(() => {
    let pageType = subcategory.value && subcategory.value.publishedTo;
    switch (pageType) {
      case '1':
        return 'info-page_external';
      case '2':
        return 'info-page_internal';
      case '3':
        return 'info-page_service';
      default:
        return '';
    }
  });

  const transformedData = computed(() => {
    const productsArr: any[] = [];
    let transformedArr: any[] = [];
    const productCard = { productBlockType: 'ProductCard', items: [] as any[] };
    const productOverview = { productBlockType: 'ProductOverview', items: [] as any[] };

    const pageData = infoPageData.value || [];
    if (pageData.length > 0) {
      for (let productBlock of pageData) {
        if (productBlock.productBlockType == 'ProductOverview') {
          productOverview.items.push(productBlock);
        } else if (productBlock.productBlockType == 'ProductCard') {
          productCard.items.push(productBlock);
        } else {
          transformedArr.push(productBlock);
        }
      }
    }

    const productCardsArr = productsArr.filter((productBlock) => productBlock.productBlockType == 'ProductCard');
    const productOverviewsArr = productsArr.filter((productBlock) => productBlock.productBlockType == 'ProductOverview');

    if (productCardsArr.length > 0) transformedArr = [...transformedArr, ...productCardsArr];
    if (productCard.items.length > 0) transformedArr.push(productCard);
    if (productOverviewsArr.length > 0) transformedArr = [...transformedArr, ...productOverviewsArr];
    if (productOverview.items.length > 0) transformedArr.push(productOverview);
    return transformedArr;
  });
</script>
